import {
  Link
} from "react-router-dom";
import { Navbar, Nav, Button, Container } from 'react-bootstrap'
import icon from "./assets/etherCartel.png"


const Navigation = ({ connectToWallet, account, isOwner, isDealer }) => {
  return (
      <Navbar expand="lg" bg="dark" variant="dark" className="mb-3">
          <Container>
              <Navbar.Brand to="/" as={Link}>
                  <img src={icon} width="40" height="40" className="" alt="" />
                  &nbsp; Ether Cartel
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="responsive-navbar-nav" />
              <Navbar.Collapse id="responsive-navbar-nav">
                  <Nav className="me-auto">
                      <Nav.Link as={Link} to="/">Home</Nav.Link>
                      {isDealer && <Nav.Link as={Link} to="/cars/create">Sell Car</Nav.Link> }
                      {isDealer && <Nav.Link as={Link} to="/cars/mine">My Listed Cars</Nav.Link> }
                      {account && <Nav.Link as={Link} to="/my-purchases">My Purchases</Nav.Link> }
                      { isOwner && 
                        <>
                          <Nav.Link as={Link} to="/dealers/create">Create Dealer</Nav.Link>
                          <Nav.Link as={Link} to="/dealers">Dealers</Nav.Link>  
                        </>
                      }
                  </Nav>
                  <Nav>
                      {account ? (
                          <Nav.Link
                              href={`https://etherscan.io/address/${account}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="button nav-button btn-sm mx-4">
                              <Button variant="outline-light">
                                  {account.slice(0, 5) + '...' + account.slice(38, 42)}
                              </Button>

                          </Nav.Link>
                      ) : (
                          <Button onClick={connectToWallet} variant="outline-light">Connect Wallet</Button>
                      )}
                  </Nav>
              </Navbar.Collapse>
          </Container>
      </Navbar>
  )

}

export default Navigation;